document.addEventListener('DOMContentLoaded', function () {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      if (!cart.attributes || !cart.attributes.browser) {
        const userAgent = navigator.userAgent;
        let browser = 'unknown';
        if (userAgent.indexOf("Chrome") > -1 && userAgent.indexOf("Edg") === -1) {
          browser = "Chrome";
        } else if (userAgent.indexOf("Firefox") > -1) {
          browser = "Firefox";
        } else if (userAgent.indexOf("Safari") > -1 && userAgent.indexOf("Chrome") === -1) {
          browser = "Safari";
        } else if (userAgent.indexOf("Edg") > -1) {
          browser = "Edge";
        } else if (userAgent.indexOf("MSIE") > -1 || userAgent.indexOf("Trident/") > -1) {
          browser = "Internet Explorer";
        }
        fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            attributes: {
              browser: browser
            }
          })
        });
      }
    });
});